import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-course',
  templateUrl: './course.component.html',
  styleUrls: ['./course.component.css']
})
export class CourseComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  public gotoContactPartners(){
    // this.router.navigateByUrl('/aep/connectpartners')
    window.open('https://aepcrt.org/', '_blank');
  }

}
